import { useMutation } from '@tanstack/react-query';
import { updateAnnualReportFirstAccess } from '@/services/user';

export function useUpdateAnnualReportFirstAccess() {
  return useMutation({
    mutationFn: () => updateAnnualReportFirstAccess()
  });
}
